import { render, staticRenderFns } from "./OtherServicePrice.vue?vue&type=template&id=03542480&"
import script from "./OtherServicePrice.ts?vue&type=script&lang=js&"
export * from "./OtherServicePrice.ts?vue&type=script&lang=js&"
import style0 from "./OtherServicePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports